import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card } from '../components/ui/Card';
import { UserRole } from '../types';
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const {
    login,
    isLoading
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const success = await login(email, password);
      if (success) {
        // Redirect is handled by ProtectedRoute or manual navigation here
        // We'll let the user effect in ProtectedRoute handle it, or force it here
        const userStr = localStorage.getItem('vipclean_session');
        if (userStr) {
          const user = JSON.parse(userStr);
          const dashboardMap: Record<UserRole, string> = {
            ADMIN: '/admin',
            CHAUFFEUR: '/driver',
            DEPOT: '/depot'
          };
          navigate(dashboardMap[user.role as UserRole]);
        }
      } else {
        setError('Identifiants incorrects');
      }
    } catch (err) {
      setError('Une erreur est survenue');
    }
  };
  // Quick fill for demo
  const fillDemo = (role: string) => {
    if (role === 'admin') {
      setEmail('admin@vipclean.tn');
      setPassword('123');
    } else if (role === 'driver') {
      setEmail('driver@vipclean.tn');
      setPassword('123');
    } else {
      setEmail('depot@vipclean.tn');
      setPassword('123');
    }
  };
  return <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center p-4" data-id="element-527">
      <div className="mb-8 text-center" data-id="element-528">
        <img src="https://vipclean.tn/wp-content/uploads/2022/08/Nouveau-projetlogovipclean-150x150.png" alt="VIP Clean" className="h-24 w-auto mx-auto mb-4" data-id="element-529" />
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-530">VIP CLEAN</h1>
        <p className="text-gray-600 mt-2" data-id="element-531">Application de gestion interne</p>
      </div>

      <Card className="w-full max-w-md" data-id="element-532">
        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-533">
          <div className="text-center mb-6" data-id="element-534">
            <h2 className="text-xl font-semibold text-gray-800" data-id="element-535">Connexion</h2>
          </div>

          {error && <div className="bg-red-50 text-red-600 p-3 rounded-lg text-sm text-center" data-id="element-536">
              {error}
            </div>}

          <Input label="Email ou Identifiant" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="nom@vipclean.tn" required autoFocus data-id="element-537" />

          <Input label="Mot de passe" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required data-id="element-538" />

          <Button type="submit" fullWidth size="lg" isLoading={isLoading} data-id="element-539">
            Se connecter
          </Button>
        </form>

        <div className="mt-8 pt-6 border-t border-gray-100" data-id="element-540">
          <p className="text-xs text-center text-gray-500 mb-3" data-id="element-541">
            Accès rapide (Démo):
          </p>
          <div className="flex gap-2 justify-center" data-id="element-542">
            <button onClick={() => fillDemo('admin')} className="text-xs bg-gray-100 px-2 py-1 rounded hover:bg-gray-200" data-id="element-543">
              Admin
            </button>
            <button onClick={() => fillDemo('driver')} className="text-xs bg-gray-100 px-2 py-1 rounded hover:bg-gray-200" data-id="element-544">
              Chauffeur
            </button>
            <button onClick={() => fillDemo('depot')} className="text-xs bg-gray-100 px-2 py-1 rounded hover:bg-gray-200" data-id="element-545">
              Dépôt
            </button>
          </div>
        </div>
      </Card>
    </div>;
}